<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>产品管理</el-breadcrumb-item>
      <el-breadcrumb-item>产品列表</el-breadcrumb-item>
    </el-breadcrumb>    
    <el-card>
      <!-- 添加产品 -->
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input
            size="small"
            clearable
            placeholder="请输入搜索内容"
            v-model="queryInfo.query"
            @clear="getList">
            <el-button
              slot="append"
              @click="getList"
              icon="el-icon-search">
            </el-button>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-button 
            type="primary" 
            size="small" 
            @click="showAddDialog">
            添加
          </el-button>
        </el-col>
      </el-row> 
      <!-- 表格 -->
      <el-row>
        <el-table :data="tableData" border stripe>
          <el-table-column 
            type="index" 
            align="center" 
            size="mini" 
            width="50">
          </el-table-column>
          <el-table-column align="center" min-width="160px" prop="name" label="名称">
            <template slot-scope="scope">
              <div>
                <span>{{ scope.row.name }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="160px" prop="name_e" label="英文名称">
            <template slot-scope="scope">
              <div>
                <span>{{ scope.row.name_e }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="160px" prop="guige_desc" label="规格">
            <template slot-scope="scope">
              <div>
                <span>{{ scope.row.guige_size }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="160px" prop="caizhi_name" label="材质">
            <template slot-scope="scope">
              <div>
                <span>{{ scope.row.caizhi_name }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="160px" prop="guangzedu_name" label="光泽度">
            <template slot-scope="scope">
              <div>
                <span>{{ scope.row.guangzedu_name }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="160px" prop="gongyi_name" label="工艺">
            <template slot-scope="scope">
              <div>
                <span>{{ scope.row.gongyi_name }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="160px" prop="yanse_name" label="颜色">
            <template slot-scope="scope">
              <div>
                <span>{{ scope.row.yanse_name }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="160px" prop="zl" label="重量(kg)">
            <template slot-scope="scope">
              <div>
                <span>{{ scope.row.zl }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="160px" prop="tz" label="托装(箱/托)">
            <template slot-scope="scope">
              <div>
                <span>{{ scope.row.tz }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="160px" prop="turn" label="新品排序（0-1000）">
            <template slot-scope="scope">
              <div>
                <span>{{ scope.row.turn }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="160px" prop="lb" label="轮播图">
            <template slot-scope="scope">
              <div style="display: flex;justify-content: center;align-items: center;">
                <img v-for="(item, index) in scope.row.lb" :src="item.url" style="width:50px;height: 50px;">
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="160px" prop="content" label="产品详情">
            <template slot-scope="scope">
              <div style="display: flex;justify-content: center;align-items: center;">
                <img v-for="(item, index) in scope.row.content" :src="item.url" style="width:50px;height: 50px;">
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center"  min-width="160px" prop="arLink" label="VR链接">
            <template slot-scope="scope" >
              <div style="color:blue;" @click="showLink(scope.row.arLink)">
                <span>{{ scope.row.arLink }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
            width="220px"
            fixed="right">
            <template slot-scope="scope">
              <el-button
                type="primary"
                icon="el-icon-edit"
                @click="showEditDialog(scope.row)"
                size="mini">
              </el-button>
              <el-button
                type="danger"
                icon="el-icon-delete"
                @click="removeUser(scope.row.id)"
                size="mini">
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>  
      <!-- 页码 -->
      <el-row>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pagenum"
          :page-sizes="[2, 5, 10, 15]"
          :page-size="queryInfo.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>      
      </el-row>   
    </el-card>

    <!-- 添加/编辑 产品 -->
    <el-dialog
      :title="`${userTitle}产品`"
      :visible.sync="userDialog"
      width="38%"
      @close="userDialogClosed">
      <el-form
       :model="userForm"
       :rules="userFormRules"
       ref="userFormRef"
       label-width="90px">
        <el-form-item label="产品名称" prop="username">
          <el-input size="small" v-model="userForm.username"></el-input>
        </el-form-item>
        <el-form-item label="英文名称" prop="name_e">
          <el-input size="small" v-model="userForm.name_e"></el-input>
        </el-form-item>
        <div style="display: flex;">
          <el-form-item label="规格" style="width: 50%;">
            <el-select v-model="userForm.guige" placeholder="请选择规格">
              <el-option
                v-for="item in guige"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="材质" style="width: 50%;">
            <el-select v-model="userForm.caizhi" placeholder="请选择材质">
              <el-option
                v-for="item in caizhi"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div style="display: flex;">
          <el-form-item label="工艺" style="width: 50%;">
            <el-select v-model="userForm.gongyi" placeholder="请选择工艺">
              <el-option
                v-for="item in gongyi"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="光泽度" style="width: 50%;">
            <el-select v-model="userForm.guangzedu" placeholder="请选择光泽度">
              <el-option
                v-for="item in guangzedu"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
       
        <div style="display: flex;">
          <el-form-item label="颜色" style="width: 50%;">
            <el-select v-model="userForm.yanse" placeholder="请选择颜色">
              <el-option
                v-for="item in yanse"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div style="display: flex;">
          <el-form-item label="重量(kg)" style="width: 50%;">
            <el-input size="small" v-model="userForm.zl"></el-input>
          </el-form-item>
          <el-form-item label="托装(箱/托)" style="width: 50%;">
            <el-input size="small" v-model="userForm.tz"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="新品排序" >
          <el-input size="small" v-model="userForm.turn"></el-input>
        </el-form-item>
        <el-form-item label="VR链接" >
          <el-input size="small" v-model="userForm.arLink"></el-input>
        </el-form-item>
        <el-form-item label="轮播图">
          <el-upload
            class="upload-demo"
            action="#"
            :file-list="fileList"
            :on-remove="handleRemove"
            :before-upload="uploadImage1"
            list-type="picture">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="商品详情">
          <el-upload
            class="upload-demo"
            action="#"
            :file-list="fileList2"
            :on-remove="handleRemove2"
            :before-upload="uploadImage2"
            list-type="picture">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="userDialog = false" size="small">取消</el-button>
        <el-button v-if="userTitle=='添加'" type="primary" @click="addUserBtn" size="small">确定</el-button>
        <el-button v-else type="primary" @click="editUser" size="small">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
<script>
import table from '@/mixins/tables'
import OSS from 'ali-oss';
export default {
  data () {
    var checkMobile = (rule, val , cb) => {
      const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
        if (regMobile.test(val)) {
          return cb()
        } else {
          cb(new Error('请输入合法手机号'))
        }
    }
    
    return {
      userTitle:'添加',
      userDialog: false,
      userForm: {
        userid:0,
        username: '',
        name_e:'',
        imageUrl:'',
        mobile: '',
        sex: '',
        plote:'',
        remork:'',
        yanse:'',
        caizhi:'',
        guige:'',
        gongyi:'',
        guangzedu:'',
        xilie:'',
        zl:'',
        tz:'',
        arLink:'',
        turn:''
      },
      userFormRules: {
        username: [
          {
            required: true,
            message: '请输入产品名',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 120,
            message: '产品名长度在 1 到 120 个字符之间',
            trigger: 'blur'
          }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' }
        ],
        sex:[
          { required: true, message: '请选择性别', trigger: 'blur' },
        ],
        plote:[
          { required: true, message: '请输入车牌号', trigger: 'blur' },
        ],
        name_e:[
          { required: true, message: '请输入产品英文名称', trigger: 'blur' },
        ]
      },  
      sexOptions: [{
          value: 0,
          label: '男'
        }, {
          value: 1,
          label: '女'
        }],
      typeOptions: [{
          value: 0,
          label: '区域管理员'
        }, {
          value: 1,
          label: '系统管理员'
        }],
      tableData: [ ],
      userCloumn: [
        { name: 'name', label: '名称', minWidth: '160px' }    
      ],  
      yanse:[],
      caizhi:[],
      xilie:[],
      guige:[],
      guangzedu:[],
      gongyi:[],
      fileList: [],
      fileList2: [],
      client:undefined,
      headers:undefined
    }
  },
  mixins: [table],
  created () {
    this.getList()
    this.getSelection()
    this.loadClient()
  },
  methods: {
    getList() {
      var that = this;
      this.$post('/apis/manage/product/productList',{
              page:that.queryInfo.pagenum-1,
              length:that.queryInfo.pagesize,
              token:sessionStorage.getItem('token'),
              name:that.queryInfo.query
          }).then(function(res){
            if(res.errno == 0){
              var newList = res.data.list;
              that.tableData = newList;
              that.total = res.data.totalCount;
            }else if(res.errno == 99){
              that.$message.info(res.errmsg);
              sessionStorage.clear();
              that.$router.push("/login");
            }else{
              that.$message.info(res.errmsg);
            }
          }).catch(function(err){
            window.console.log(err);
          });
      
    },
    getSelection() {
      var that = this;
      this.$post('/apis/manage/product/productSelection',{
              token:sessionStorage.getItem('token')
          }).then(function(res){
            if(res.errno == 0){

              var data = res.data;
              //console.log(data)
              that.yanse = data.yanse
              that.caizhi = data.caizhi
              that.gongyi = data.gongyi
              that.guangzedu = data.guangzedu
              that.guige = data.guige
              that.xilie = data.xilie
            }else if(res.errno == 99){
              that.$message.info(res.errmsg);
              sessionStorage.clear();
              that.$router.push("/login");
            }else{
              that.$message.info(res.errmsg);
            }
          }).catch(function(err){
            window.console.log(err);
          });
      
    },
    loadClient(){
      // 配置OSS客户端
      this.client = new OSS({
        region: 'oss-cn-hangzhou',
        accessKeyId: 'LTAI5t7cyydtfHCta1dgFCuA',
        accessKeySecret: 'x0lQnzUbb7tQscZ0nVpxndoNv1yUu7',
        bucket: 'zxcl',
      });
      // 自定义请求头
      this.headers = {
        // 指定Object的存储类型。
        'x-oss-storage-class': 'Standard',
        // 指定Object的访问权限。
        'x-oss-object-acl': 'public-read-write',
        // 通过文件URL访问文件时，指定以附件形式下载文件，下载后的文件名称定义为example.txt。
        'Content-Disposition': 'inline',
        // 设置Object的标签，可同时设置多个标签。
        'x-oss-tagging': 'Tag1=1&Tag2=2',
        // 指定PutObject操作时是否覆盖同名目标Object。此处设置为true，表示禁止覆盖同名Object。
        'x-oss-forbid-overwrite': 'false',
      };

    },
    showAddDialog() {
      this.userDialog = true
      this.userTitle = '添加'
    },
    userDialogClosed() {
      this.$refs.userFormRef.resetFields()
      this.userForm.username = ""
      this.userForm.userid = ""
      this.userForm.caizhi = ''
      this.userForm.gongyi = ''
      this.userForm.guangzedu = ''
      this.userForm.guige = ''
      this.userForm.xilie = ''
      this.userForm.yanse = ''
      this.userForm.zl = ''
      this.userForm.tz = ''
      this.userForm.arLink = ''
      this.userForm.turn = ''
      this.userForm.name_e = ''
      this.fileList = []
      this.fileList2 = []
    },
    addUserBtn() {
      this.$refs.userFormRef.validate( valid => {
        if (valid) {
          var that = this;
          this.$post('/apis/manage/product/addProduct',{
              username:this.userForm.username,
              token:sessionStorage.getItem('token'),
              caizhi:this.userForm.caizhi,
              gongyi:this.userForm.gongyi,
              name_e:this.userForm.name_e,
              guangzedu:this.userForm.guangzedu,
              guige:this.userForm.guige,
              xilie:this.userForm.xilie,
              yanse:this.userForm.yanse,
              zl:this.userForm.zl,
              tz:this.userForm.tz,
              arLink:this.userForm.arLink,
              turn:this.userForm.turn,
              lb:JSON.stringify(this.fileList),
              content:JSON.stringify(this.fileList2)
          }).then(function(res){
            if(res.errno == 0){
              that.$message.success('产品添加成功');
              that.userDialog = false;
              that.getList();
            }else{
              that.$message.info(res.errmsg);
            }
          }).catch(function(err){
            window.console.log(err);
          });
        }
      }) 
    },
    showEditDialog(row) {
      console.log('显示编辑产品');
      this.userDialog = true
      this.userTitle = '编辑'
      this.userForm.username = row.name
      this.userForm.userid = row.id
      this.userForm.caizhi = row.caizhi_id
      this.userForm.gongyi = row.gongyi_id
      this.userForm.guangzedu = row.guangzedu_id
      this.userForm.guige = row.guige_id
      this.userForm.xilie = row.xilie_id
      this.userForm.yanse = row.yanse_id
      this.userForm.zl = row.zl
      this.userForm.tz = row.tz
      this.userForm.turn = row.turn
      this.userForm.arLink = row.arLink
      this.userForm.name_e = row.name_e
      this.fileList = row.lb
      this.fileList2 = row.content
    },
    editUser() {
      this.$refs.userFormRef.validate( valid => {
        if (valid) {
          var that = this;
          this.$post('/apis/manage/product/editProduct',{
              userid:this.userForm.userid,
              username:this.userForm.username,
              name_e:this.userForm.name_e,
              caizhi:this.userForm.caizhi,
              gongyi:this.userForm.gongyi,
              guangzedu:this.userForm.guangzedu,
              guige:this.userForm.guige,
              xilie:this.userForm.xilie,
              yanse:this.userForm.yanse,
              zl:this.userForm.zl,
              tz:this.userForm.tz,
              arLink:this.userForm.arLink,
              turn:this.userForm.turn,
              lb:JSON.stringify(this.fileList),
              content:JSON.stringify(this.fileList2),
              token:sessionStorage.getItem('token'),
          }).then(function(res){
            if(res.errno == 0){
              that.$message.success('产品信息修改成功');
              that.userDialog = false;
              that.getList();
            }else{
              that.$message.info(res.errmsg);
            }
          }).catch(function(err){
            window.console.log(err);
          });
        }
      }) 
    },
    showLink(url){
      console.log(url)
      window.open(url)
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
      //console.log(file, fileList,this.fileList);
    },
    handleRemove2(file, fileList) {
      this.fileList2 = fileList
      //console.log(file, fileList,this.fileList);
    },
    removeUser(id) {
      var that = this;
      const confirmResult = this.$confirm(
        '此操作将永久删除该产品，请确认该产品下是否存在产品，是否继续？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'          
        }
      ).then(async () => { //  不要忘记加 async
              window.console.log(1);
              that.$post('/apis/manage/product/delProduct',{
                userid:id,
                token:sessionStorage.getItem('token'),
              }).then(function(res){
                if(res.errno == 0){
                  that.$message.success('产品删除成功');
                  that.getList();
                }else{
                  that.$message.info(res.errmsg);
                }
              }).catch(function(err){
                
                window.console.log(2);
              });
            
        }).catch(err => err)
    },
    async uploadImage1(file) {
      console.log('上传图片1');
      console.log(file);
      let that = this
      //const file = event.target.files[0];
      if (!file) return;
      try {
       
      // 自定义请求头
      let headers = that.headers
        // 上传图片
        console.log('上传图片1');
        let now = Date.now()
        let newName = now +'_'+ file.name
        const result = await this.client.put(newName, file,{headers});
        console.log(result);
        if(result.name != undefined && result.name != ''){
          that.fileList.push(
            {name:result.name,url:result.url}
          )
          //that.userForm.imageUrl = result.url
        }
      } catch (e) {
        console.error(e);
      }
    },
    async uploadImage2(file) {
      console.log('上传图片2');
      console.log(file);
      let now = Date.now()
      let newName = now +'_'+ file.name
      let that = this
      //const file = event.target.files[0];
      if (!file) return;
      try {
        // 上传图片
        let headers = that.headers
        console.log('上传图片2');
        const result = await this.client.put(newName, file,{headers});
        console.log(result);
        if(result.name != undefined && result.name != ''){
          that.fileList2.push(
            {name:result.name,url:result.url}
          )
          //that.userForm.imageUrl = result.url
        }
      } catch (e) {
        console.error(e);
      }
    },
  }
}
</script>
